// import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Layout, Avatar } from "antd";
import PropTypes from "prop-types";
import React from "react";
import Menus from "@/components/Menus";
import styles from "./layout.module.less";
import Logo from "@/assets/logo.svg";
// import { toggleCollapsed } from "@/store/reducers/appSlice";
import { useSelector } from "react-redux";
import store2 from "store2";
import { USERINFO } from "@/config";

const Sider = React.memo((props) => {
  // const dispatch = useDispatch();
  const app = useSelector((state) => state.app);
  const user = store2(USERINFO) || {};

  return (
    <Layout.Sider
      theme="light"
      trigger={null}
      width={250}
      collapsedWidth={48}
      collapsible
      collapsed={app.collapsed}
      className={styles.sider}
    >
      <div className={styles.siderLogo}>
        {!app.collapsed && (
          <div className={styles.siderLogoTitle}>萝卜屋 Admin</div>
        )}
      </div>
      <div className={styles.siderChildren}>
        <Menus routes={props.routes} />
      </div>
    </Layout.Sider>
  );
});

Sider.displayName = "Sider";

Sider.propTypes = {
  refresh: PropTypes.func,
  routes: PropTypes.array.isRequired
};

export default Sider;
